import React from 'react';
import Tabs from 'components/layout/Tabs/Tabs';

export default function WorkerTabs() {
  const tabs = [
    { name: 'All workers', href: '/workers' },
    { name: 'Create worker', href: '/workers/add' },
    { name: 'Widgets', href: '/workers/widgets' },
  ];

  return <Tabs tabs={tabs} />;
}